import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

// Helpers
import { checkValidity, closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import moment from 'moment';

const ReportFilter = observer(class ReportFilter extends React.Component {
	componentWillMount() {
		const { reportFilters } = this.props.store.ReportStore;

		this.state = {
			examOpenDate: null,
			examCloseDate: null
		}

		if(reportFilters.examOpenDate) {
			this.setState({
				examOpenDate: moment(reportFilters.examOpenDate)
			});
		}

		if(reportFilters.examCloseDate) {
			this.setState({
				examCloseDate: moment(reportFilters.examCloseDate)
			});
		}
	}

  handleChange(key, value, exact) {
		const { ReportStore } = this.props.store;
    const { reportFilters } = ReportStore;

		if(value) {
			if(exact) {
	      reportFilters[key] = value;
	    } else {
	      reportFilters[key] = `*${value}*`;
	    }
		} else {
			delete reportFilters[key];
		}

		if(key === 'courseOfferingSid') {
			ReportStore.defaultCourseOffering = false;
		}
  }

  handleDateChange(date, key) {
    const { reportFilters } = this.props.store.ReportStore;
    const formattedDate = moment(date).local().toISOString();

    reportFilters[key] = formattedDate;

    // Store the new date in state for display
    this.setState({
      [key]: date
    });
  }

	handleSubmit(e) {
    const { ReportStore } = this.props.store;

    closeDrawer(e, this.props.parent);

    ReportStore.getReportData(getURLSegment(this, 2));
  }

  render() {
  	const { translation } = this.props;
    const { AdminStore, ReportStore, SessionStore } = this.props.store;
		const { courseOfferings } = AdminStore;
    const { reportFilters, reportFilterMap } = ReportStore;

		let showOfferingFilter = true;

		if(getURLSegment(this, 1) === 'instructor-appointments' || getURLSegment(this, 2) === 'session-requests') {
			showOfferingFilter = false;
		}

    if(!SessionStore.loading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">Filter Report</h1>
            </div>
          </header>

          <div className="panel panel--brief">
            <form className=""  onSubmit={(e) => checkValidity(e, (e) => this.handleSubmit(e))} noValidate>
              <fieldset>
                <ul className="fields">
									{showOfferingFilter &&
										<li>
	                    <label htmlFor="courseOfferings">
	                      {translation.course_offering.label}
	                    </label>

	                    <label className="select">
	                      <select
	                        defaultValue={reportFilters.courseOfferingSid}
	                        id="courseOfferings"
													onChange={(e) => this.handleChange('courseOfferingSid', e.target.value, true)}
	                      >
	                        <option  value="">{translation.course_offering.helper}</option>
	                        {courseOfferings.map((offering, i) => {
	                          return (
															<option value={offering.sid} key={i}>{offering.title}</option>
														)
	                        })}
	                      </select>
	                    </label>
	                  </li>
									}

                  {Object.keys(reportFilterMap).map(
                    (key, i) => {
                      const dataType = typeof reportFilterMap[key];

                      if(dataType === 'number' && key !== 'courseOfferingSid') {
                        return (
                          <li
                            key={i}
                            className="field--select-text"
                          >
                            <label htmlFor={key}>{translation[key] || key}</label>
                            <label className="select">
                              <select id={key}>
                                <option value="=">{translation.number.equals}</option>
                                <option value=">">{translation.number.greater_than}</option>
                                <option value="<">{translation.number.less_than}</option>
                              </select>
                            </label>
                            <input type="number" id="" placeholder="0" />
                          </li>
                        )
                      } else if(typeof reportFilterMap[key] === 'string' && key !== 'courseOfferingSid' && reportFilterMap[key] !== 'date') {
                        return (
                          <li
                            key={i}
                          >
                            <label htmlFor={key}>
                              {translation[`${key}_label`] || key}
                            </label>

                            <input
                              id={key}
                              type="text"
                              defaultValue={
  															reportFilters[key] ?
  															reportFilters[key].replace(/%20/g, ' ').replace(/^\*/, '').replace(/\*$/, '') :
  															''
  														}
                              onChange={((e) => this.handleChange(key,e.target.value))} placeholder={translation[`${key}_helper`] || ''}
                            />
                          </li>
                        )
                      } else if(typeof reportFilterMap[key] === 'string' && reportFilterMap[key] === 'date') {
  											let date = null;

  											if(this.state[key]) {
  												date = moment(this.state[key]);
  											} else if(reportFilters[key]) {
  												date = moment(reportFilters[key]);
  											}

  											return (
  												<li
  													key={i}
  												>
  													<label htmlFor={key}>
  														{translation[`${key}_label`] || key}
  													</label>

  													<DatePicker
  														id={key}
  														selected={date}
  														onChange={(date, e) => {this.handleDateChange(date, key, e)}}
  														placeholderText="mm/dd/yyyy"
  														autoComplete="off"
  														required={this.state.examOpenDate || this.state.examCloseDate}
  													/>
  												</li>
  											)
                      } else if(typeof reportFilterMap[key] === 'boolean') {
                      	return (
  	                    	<li
  	                    		key={i}
  	                    	>
  													<label htmlFor={key}>
  				                  	{translation[`${key}_label`] || key}
  				                  </label>

  				                  <label className="select">
  				                    <select
  				                      defaultValue={reportFilters[key]}
  				                      id={key}
  															onChange={(e)=>{this.handleChange(key, e.target.value, true)}}
  				                    >
  				                      <option value="">---</option>
  				                      <option value={true}>True</option>
  				                      <option value={false}>False</option>
  				                    </select>
  				                  </label>
  			                  </li>
                      	)
                      } else if(Array.isArray(toJS(reportFilterMap[key]))) {
  											return (
  												<li
  													key={i}
  												>
  													<label htmlFor={key}>
  														{translation[`${key}_label`] || key}
  													</label>

  													<label className="select">
  														<select
  															id={key}
  															onChange={(e) => this.handleChange(key, e.target.value, true)}
  															defaultValue={reportFilters[key]}
  														>
  															<option value="">{translation[`${key}_helper`]}</option>
  															{reportFilterMap[key].map(
  																(option, i) =>
  																	<option
  																		value={option}
  																		key={i}
  																	>
  																		{translation[`${option}_label`]}
  																	</option>
  															)}
  														</select>
  													</label>
  												</li>
  											)
  										}

                      return '';
                    }
                  )}
                </ul>
              </fieldset>
              <button className="btn" type="submit">{translation.button}</button>
            </form>
          </div>
        </div>
      )
    }

    return null;
	}
});

export default translate('FilterReport')(ReportFilter);



// WEBPACK FOOTER //
// ./src/app/components/Reports/ReportFilter.js